import { getPath } from '@/router/common'

const baseUrl = {
  title: '登录审核',
  path: 'BindingEquipment'
}

export default [
  {
    path: getPath('index', baseUrl),
    name: 'BindingEquipmentIndex',
    component: () => import('@/views/BindingEquipment/index/index.vue'),
    meta: {
      title: '登录审核'
    }
  }
]
